/**
 * Моды таймера
 */
export default class TimerEnums
{
    public static readonly TIMER_MODE = 'timer';
    public static readonly STOPWATCH_MODE = 'stopwatch';
}
